import * as React from 'react';
import { addClass, isValidLength, Bem } from '../../utils/css.js';
import '../../constants.js';
import { FormInfo } from './Info/FormInfo.js';
import { FormItem } from './Item/FormItem.js';
import { useId } from '../../utils/hooks/useId.js';
import './Form.scss.js';

const bem = Bem.create("vai-form");
const defaultMaxWidth = "450px";
const Form = React.forwardRef(function Form2(props, ref) {
  const {
    children,
    htmlId,
    dataTa,
    className,
    isCentered = true,
    maxWidth = defaultMaxWidth,
    style,
    mode = "auto",
    preventDefault = true,
    onSubmit,
    ...rest
  } = props;
  const id = useId(htmlId, ["form"]);
  const classNames = addClass(className, bem.block(isCentered ? "centered" : "", mode));
  const inlineStyle = {
    maxWidth: isValidLength(maxWidth) ? maxWidth : defaultMaxWidth,
    ...style
  };
  const handleOnSubmit = (event) => {
    if (preventDefault) {
      event.preventDefault();
    }
    if (onSubmit) {
      onSubmit(event);
    }
  };
  return /* @__PURE__ */ React.createElement("form", {
    id: id.toString(),
    className: classNames,
    "data-ta": dataTa,
    onSubmit: handleOnSubmit,
    style: inlineStyle,
    ...rest
  }, children);
});
Form.Info = FormInfo;
Form.Item = FormItem;

export { Form };
